/** Route-level loading placeholder. Static text on purpose: no spinner animation. */
export const LoadingPage = () => {
  return (
    <output
      aria-busy="true"
      className="text-muted-foreground flex h-24 w-full items-center justify-center text-xs/relaxed"
    >
      Carregando...
    </output>
  );
};
